module.exports = __webpack_public_path__ + "7fdfdb85c2cbf35c4d8a8e30e27cbc92.svg";